<template>
    <div class="col-12 col-md-12 col-lg-10 col-xl-10" >
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-10 col-xl-10">
                <div class="tit text-center">
                    <h2>2. Avaliação de tolerância a risco</h2>
                </div>
                <form @submit="onSubmit">
                    <div class="item">
                        <p><strong>a.</strong> Conhecimento e Experiência: Informe o seu grau de conhecimento e experiência, o volume e a frequência das operações em cada uma das classes de produtos, levando em consideração as ponderações abaixo:</p>

                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10"></td>
                                    <td>
                                        <p for="" class="form-check-label">
                                            <b>Baixo</b>: Não tenho familiaridade com o produto ou a classe de ativo.
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10"></td>
                                    <td>
                                        <p for="" class="form-check-label">
                                            <b>Médio</b>: Compreendo as características e os riscos, porém não tenho nem realizei investimento no produto ou na classe de ativo, em volumes superiores a 5% da minha carteira há mais de 2 anos.
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10"></td>
                                    <td>
                                        <p for="" class="form-check-label">
                                            <b>Alto</b>: Tenho e/ou realizei investimentos no produto ou na classe em volumes superiores a 5% da minha carteira há mais de 2 anos.
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="item row justify-content-center">
                        <div class="col-12 col-md-8">
                            <table class="table table-responsive">
                                <thead>
                                    <tr>
                                        <th scope="col" width="200">&nbsp;</th>
                                        <th scope="col" width="80">Baixo</th>
                                        <th scope="col" width="80">Médio</th>
                                        <th scope="col" width="80">Alto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">Renda fixa</th>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="RendaFixa" id="" value="1" v-model="RendaFixa">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="RendaFixa" id="" value="2" v-model="RendaFixa">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="RendaFixa" id="" value="3" v-model="RendaFixa">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Fundos multimercados e estruturados</th>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="FundosMultimercados" id="" value="1" v-model="FundosMultimercados">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="FundosMultimercados" id="" value="2" v-model="FundosMultimercados">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="FundosMultimercados" id="" value="3" v-model="FundosMultimercados">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Renda variável</th>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="RendaVariavel" id="" value="1" v-model="RendaVariavel">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="RendaVariavel" id="" value="2" v-model="RendaVariavel">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="RendaVariavel" id="" value="3" v-model="RendaVariavel">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Fundos imobiliários</th>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="FundosImobiliarios" id="" value="1" v-model="FundosImobiliarios">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="FundosImobiliarios" id="" value="2" v-model="FundosImobiliarios">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="FundosImobiliarios" id="" value="3" v-model="FundosImobiliarios">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Derivativos, COE e Private Equity</th>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="Derivativos" id="" value="1" v-model="Derivativos">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="Derivativos" id="" value="2" v-model="Derivativos">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="checkContainer checkTable">
                                                <input type="radio" name="Derivativos" id="" value="3" v-model="Derivativos">
                                                <span class="checkmark"></span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="item">
                        <p><strong>b.</strong> Expectativa: Você acredita que, em períodos de mais de três anos, produtos de maior risco (ex. ações) são mais atrativos do que produtos de menor risco?</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="ExpectativaAtrativos" class="form-check-input" id="" value="1" v-model="ExpectativaAtrativos">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td><label for="" class="form-check-label">Não</label></td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="ExpectativaAtrativos" class="form-check-input" id="" value="2" v-model="ExpectativaAtrativos">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td><label for="" class="form-check-label">Depende</label></td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="ExpectativaAtrativos" class="form-check-input" id="" value="3" v-model="ExpectativaAtrativos">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td><label for="" class="form-check-label">Sim</label></td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="item">
                        <p><strong>c.</strong> Conforto: Como você reagiria se os seus investimentos caíssem mais de 10% (mesmo que temporariamente)?</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Conforto" class="form-check-input" id="" value="1" v-model="Conforto">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">Venderia imediatamente.</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Conforto" class="form-check-input" id="" value="2" v-model="Conforto">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">Entendo que isso pode acontecer para determinados ativos, mas não para o portfólio como um todo.</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Conforto" class="form-check-input" id="" value="3" v-model="Conforto">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">Entendo que o meu portfólio está sujeito a sofrer flutuações dessa magnitude.</label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="item">
                        <p><strong>d.</strong> Expectativa dos investimentos.</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Expectativa"  class="form-check-input" id="" value="1" v-model="Expectativa">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Não admito perder nada do capital investido. Procuro um retorno seguro e sem oscilações. Segurança é mais importante do que rentabilidade.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Expectativa"  class="form-check-input" id="" value="2" v-model="Expectativa">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Não admito perder nada do capital investido, no entanto, posso arriscar uma parte do capital para alcançar resultados melhores que a renda fixa tradicional.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Expectativa"  class="form-check-input" id="" value="3" v-model="Expectativa">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Posso correr riscos para conseguir uma rentabilidade acima da média, no entanto, prezo a preservação de 100% do capital investido. Divido minhas preferências entre segurança e rentabilidade, mas ainda prefiro segurança à rentabilidade.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Expectativa"  class="form-check-input" id="" value="4" v-model="Expectativa">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Admito perdas de até 20% do capital investido, se a proposta de investimento gerar possibilidade de altos retornos. A procura por rentabilidade é mais importante do que segurança.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Expectativa"  class="form-check-input" id="" value="5" v-model="Expectativa">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Minha prioridade é maximizar a rentabilidade, com segurança em segundo plano. Posso correr grandes riscos para obter elevados retornos, admitindo perder mais de 20% do meu principal investido.
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="item">
                        <p><strong>e.</strong> Formação acadêmica e experiência profissional: Você considera que sua formação acadêmica e/ou experiência profissional lhe traz conhecimento sobre o mercado financeiro?</p>
                        <div class="form-check">
                            <table class="forms">
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Formacao" class="form-check-input" id="" value="1" v-model="Formacao">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Nenhum ou pouco conhecimento para entender a relação risco-retorno de produtos complexos.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Formacao" class="form-check-input" id="" value="2" v-model="Formacao">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Algum conhecimento para entender a relação risco-retorno de produtos complexos.
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="10">
                                        <div class="checkContainer suitability">
                                            <input type="radio" name="Formacao" class="form-check-input" id="" value="3" v-model="Formacao">
                                            <span class="checkmark"></span>
                                        </div>
                                    </td>
                                    <td>
                                        <label for="" class="form-check-label">
                                            Conhecimento para entender a relação risco-retorno de produtos complexos.
                                        </label>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="text-center fixedOptions">
                         <form @submit="onSubmit">
                            <button class="btn btn-lg btn-primary" :disabled="verificaPreenchimento()">Próximo <img src="/static/assets/images/angle-right.svg"></button>
                         </form>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/styles/iouu/_mixins.scss';
    
    @include sm {
        .steps .form-container .tit {
            margin-top: 0;
        }
    }
</style>



<script>
     export default {
  data() {
    const AvaliacaoRisco = this.suitability.AvaliacaoRisco
    return {
      RendaFixa: AvaliacaoRisco ? AvaliacaoRisco.RendaFixa : null,
      FundosMultimercados: AvaliacaoRisco ? AvaliacaoRisco.FundosMultimercados : null,
      RendaVariavel: AvaliacaoRisco ? AvaliacaoRisco.RendaVariavel : null,
      FundosImobiliarios: AvaliacaoRisco ? AvaliacaoRisco.FundosImobiliarios : null,
      Derivativos: AvaliacaoRisco ? AvaliacaoRisco.Derivativos : null,
      ExpectativaAtrativos: AvaliacaoRisco ? AvaliacaoRisco.ExpectativaAtrativos : null,
      Conforto: AvaliacaoRisco ? AvaliacaoRisco.Conforto : null,
      Expectativa: AvaliacaoRisco ? AvaliacaoRisco.Expectativa : null,
      Formacao: AvaliacaoRisco ? AvaliacaoRisco.Formacao : null
    }
  },
  props: {
    suitability: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      this.$emit('on-submit', {
        AvaliacaoRisco: {
            RendaFixa: this.RendaFixa,
            FundosMultimercados: this.FundosMultimercados,
            RendaVariavel: this.RendaVariavel,

            FundosImobiliarios: this.FundosImobiliarios,
            Derivativos: this.Derivativos,
            ExpectativaAtrativos: this.ExpectativaAtrativos,
            Conforto: this.Conforto,
            Expectativa: this.Expectativa,
            Formacao: this.Formacao
        }
      })
    },
    verificaPreenchimento(){
      let  retorno =   this.RendaFixa == null || this.FundosMultimercados == null || this.RendaVariavel == null;
      retorno =  retorno ||  this.FundosImobiliarios == null || this.Derivativos == null || this.ExpectativaAtrativos == null || this.Conforto == null;
      retorno =  retorno ||  this.Expectativa == null || this.Formacao == null;

      return retorno;
    }
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InformationSuitability/AvaliacaodeRisco.vue